import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_clear",
  "use": "icon-ic_clear-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-ic_clear\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-3-3h36v36H-3z\" /><path d=\"M15 30C6.716 30 0 23.285 0 15 0 6.716 6.716 0 15 0c8.285 0 15 6.716 15 15 0 8.285-6.715 15-15 15Zm0-17.121-4.242-4.243-2.122 2.122L12.879 15l-4.243 4.242 2.122 2.122L15 17.121l4.242 4.244 2.122-2.123L17.121 15l4.244-4.242-2.123-2.122L15 12.879Z\" fill=\"#CCC\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol